<template>
  <div style="overflow-x: hidden">
    <v-container grid-list-md>
      <v-layout wrap>
        <v-flex
          xs6
          sm6
          md9
        >
          <h4 style="color:#2E7D32; margin-bottom: 0px">ADD SHIP ONLY</h4>
        </v-flex>
        <v-flex
          xs6
          sm6
          md3
          style="padding-top: 5px; "
        >
          <v-btn
            flat
            outline
            color="green"
            @click="showWarehouseSection()"
            style="height:auto; padding-left: 0px; padding-right: 0px"
          >
            Purchase Via
            <i
              :class="x === 1 ? 'fa fa-angle-down' : 'fa fa-angle-up'"
              style="font-size: 20px"
            />
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>

    <div
      class="col-dm-12 col-md-12"
      style="margin-top: 10px ; border-top-style: solid; border-width: 2px; border-color: #388E3C;"
    >
      <div
        style="display: none"
        id="ware"
      >
        <div class="col-sm-12 col-md-5 col-md-offset-1">
          <h6 class="my-2"><b>Name: </b> SL/shipzone/Jose/{{ loggedInUserData.phone_number }}</h6>
          <h6 class="my-2"><b>Address: </b> {{ usaWarehouse.street }}</h6>
          <h6 class="my-2"><b>City: </b> {{ usaWarehouse.city }}</h6>
          <h6 class="my-2"><b>State: </b>{{ usaWarehouse.state_province }}</h6>
          <h6 class="my-2"><b>Zip code: </b>{{ usaWarehouse.code }}</h6>
          <h6 class="my-2"><b>{{ usaWarehouse.country }}</b></h6>
          <h6 class="my-2">{{ usaWarehouse.phone_number }}</h6>
        </div>
        <div
          class="col-md-12"
          style="border-bottom-style: solid; border-width: 2px; border-color: lightgrey"
        ></div>
      </div>
    </div>
    <!-- <div
      class="col-dm-12 col-md-12"
      style="margin-top: 10px ; border-top-style: solid; border-width: 2px; border-color: #388E3C;"
    >
    </div> -->

    <form @submit.prevent="submitForm()">
      <v-card-text style="padding-top: 0px">
        <v-alert
          type="success"
          :value="isDone"
        >
          Ordered successfully
        </v-alert>
        <v-container grid-list-md>
          <div class="col-md-5">
            <v-text-field
              label="Product Name*"
              v-model="form.product_name"
              :error-messages="errors.collect('product_name')"
              v-validate="'required'"
              data-vv-name="product_name"
            />
          </div>

          <div class="col-md-5">
            <v-text-field
              label="Product url"
              v-model="form.product_url"
            />
          </div>

          <div class="col-md-5">
            <v-text-field
              label="Quantity"
              v-model="form.quantity"
            />
          </div>

          <div class="col-md-5">
            <v-select
              :items="warehouses"
              item-value="value"
              v-model="form.warehouse_id_fk"
              :error-messages="errors.collect('warehouse_id_fk')"
              data-vv-name="warehouse_id_fk"
              label="Warehouse*"
              v-validate="'required'"
              single-line
            >
            </v-select>
          </div>

          <div class="col-md-5">
            <v-text-field
              label="Weight"
              v-model="form.item_weight"
            >
            </v-text-field>
          </div>

          <div class="col-md-5">
            <v-text-field
              label="Volume"
              v-model="form.volume"
            >
            </v-text-field>
          </div>

          <div class="col-md-5">
            <v-text-field
              label="Track number"
              v-model="form.track_number"
              data-vv-name="track_number"
              @input="removeSpaces()"
            >
            </v-text-field>
          </div>

          <div class="col-md-5">
            <v-text-field
              label="Note"
              v-model="form.note"
            >
            </v-text-field>
          </div>
        </v-container>
      </v-card-text>
      <div class="col-sm-10 col-md-5 col-md-offset-3">
        <v-btn
          type="submit"
          :loading="loading"
          style="width: 95%; height:auto; margin-bottom: 3%"
          color="success"
        >Add</v-btn>
      </div>
    </form>
  </div>
</template>
<script>
import axios from 'axios'

export default {
  mounted() {
    this.getLoggedInUser()
    this.getWarehouses()
    this.getWarehousesToSelect()
  },

  $_veeValidate: {
    validator: 'new'
  },

  data() {
    return {
      loggedInUserData: {},
      loading: false,
      form: {},
      warehouses: [],
      isDone: false,
      x: 1,
      usaWarehouse: {}
    }
  },

  methods: {
    getWarehouses() {
      let token = localStorage.getItem('access_token')
      axios
        .get('api/warehouses', { headers: { Authorization: 'Bearer ' + token } })
        .then(response => {
          this.usaWarehouse = response.data.data[0]
        })
    },

    showWarehouseSection() {
      if (this.x === 1) {
        this.x = 2
        $('#ware').show('slow')
      } else if (this.x === 2) {
        this.x = 1
        $('#ware').hide('slow')
      }
    },

    removeSpaces() {
      this.form.track_number = this.form.track_number.replaceAll(/\s+/g, '')
    },

    getWarehousesToSelect() {
      let token = localStorage.getItem('access_token')
      axios
        .get('api/warehouses', { headers: { Authorization: 'Bearer ' + token } })
        .then((response) => {
          let result = response.data.data
          result.forEach((r) => {
            this.warehouses.push({ text: r.country, value: r.warehouse_id })
          })
        })
    },

    closeDialog() {
      this.$validator.reset()
      this.form = {}
    },

    submitForm() {
      let token = localStorage.getItem('access_token')

      this.$validator.validateAll().then((res) => {
        if (res) {
          axios
            .post('api/customer/store_ship_only_order', this.form, {
              headers: { Authorization: 'Bearer ' + token }
            })
            .then(() => {
              this.isDone = true
              this.form = {}
              setTimeout(() => {
                this.isDone = false
              }, 2000)
            })
        }
      })
    },

    getLoggedInUser() {
      this.loggedInUserData = JSON.parse(localStorage.getItem('user_data'))
    }
  }
}
</script>

<style scoped>
.panel-heading {
  color: #006b8d;
  border-bottom: 2px solid #006b8d !important;
}

.panel-heading h4 {
  text-transform: uppercase;
  margin-left: -20px;
  padding-left: 10px;
  font-weight: 500;
}

.panel-flat {
  overflow-x: hidden !important;
}
</style>



// WEBPACK FOOTER //
// src/components/customer/addNewShipOnly.vue